import type { ShipmentColumn } from '../../types/column-types'
import Shipment from '../../../../types/api/shipment'
import { onCellStandard, renderShipment } from '../../helpers/helpers'
import Lacquers from '../../components/cells/lacquers/lacquers'
import ShipmentLacquersPopover from '../../components/cells/form-items/shipment-lacquers-popover'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { hasTaskOfType } from '../../helpers/has-task-of-type'

export const lacquersColumn: ShipmentColumn = {
    key: 'lacquers',
    dataIndex: ['lacquers'],
    title: <RotatedTitle>Лак</RotatedTitle>,
    width: 30,
    editable: true,
    fieldDescriptors: [
        {
            name: 'lacquers',
            getValue: (record: Shipment) =>
                record.lacquers?.map(l => ({
                    type: l.type?.documentId,
                    name: l.name || '',
                })) ?? [],
        },
    ],
    FormItem: <ShipmentLacquersPopover />,
    render: renderShipment(shipment => <Lacquers data={shipment} />),
    onCell: (record, index) => ({
        ...onCellStandard(record, index),
        editable: !hasTaskOfType(record, 'Заказ форм')
    }) as any,
}
